<template>
  <!-- PageHeader 상단 색상 입힌것 -->
  <!-- <div class="pageHeader" > 
    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ breadcrumbs[0].text }}</span>
  </div> -->
  <v-layout row class="align-center layout px-4 pt-0 app--page-header">
    <div class="page-header-left ">
      <img v-bind:src="computePageHeaderIcon" style="margin-bottom:-8px;">
      <span><h4 class="pr-3" style="font-weight: 700;">{{breadcrumbs[0].text}}</h4></span>
    </div>
    <!-- <v-icon small>home</v-icon>
    <v-breadcrumbs divider="-" :items="breadcrumbs">
    </v-breadcrumbs> -->
    <v-spacer></v-spacer>
    <!-- <div class="page-header-right" style="max-width:700px;">
      <v-layout>
        <v-icon :color="!isNotice ? '#616161' : '#EF5350'" >{{ !isNotice ? 'person' : 'mdi-message-alert' }}</v-icon>
        <h5 class="pr-3" :style="!isNotice ? 'color:#616161' : 'color:#EF5350'">&nbsp;&nbsp;{{ noticeMsg }}</h5>
      </v-layout>
    </div>
    <div class="page-header-right">
    </div> -->
  </v-layout>
</template>

<script>
import menu from '@/api/menu';
import moment from 'moment';
import timezone from 'moment-timezone';

export default {
  data () {
    return {
      title: '',
      isRefreshButton: false,
      noticeMsg: '',
      isNotice: false
    };
  },
  computed: {
    breadcrumbs: function () {
      let breadcrumbs = [];
      menu.forEach(item => {
        if (item.items) {
          let child =  item.items.find(i => {
            return i.component === this.$route.name;
          });
          if (child) {
            breadcrumbs.push({ text: this.$t(item.title) });
            breadcrumbs.push({ text: this.$t(child.title) });
            this.title = this.$t(child.title);
            this.isRefreshButton = item.refresh;
          }
        } else {
          if (item.name === this.$route.name) {
            this.title = this.$t(item.title);
            breadcrumbs.push({ text: this.$t(item.title) });
            this.isRefreshButton = item.refresh;
          }
        }
      });
      return breadcrumbs;
    },  
    computePageHeaderIcon () {
      return '/static/page_header.png';
    }
  },
  methods: {
  }
};
</script>

<style lang="stylus">
.pageHeader {
  background: #03526D;
  height: 50px;
  font-size: 17px;
  font-weight: 700;
  width: calc(200vh - 48px);
  text-align: left;
  display: table-cell;
  vertical-align: middle;
}

.pageHeader span{
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue